module.exports = __webpack_public_path__ + "media/images/lig/shirt-carousel/shirt-02-9883b6da70a0998fc582729264e60546.jpg";